import { createSelector } from '@ngrx/store';

import { selectCoreState } from '../reducers';

export const getCustomizationViewState = createSelector(selectCoreState, state => state.customizationView);

export const selectedCustomizationPage = createSelector(getCustomizationViewState, state => state.selectedPage);
